import { render, staticRenderFns } from "./loginPassPhraseConfirmation.vue?vue&type=template&id=7b2eae0d&"
import script from "./loginPassPhraseConfirmation.vue?vue&type=script&lang=js&"
export * from "./loginPassPhraseConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports